import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../Components/InnerLayout/Headerbar";
const Counts = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div class="row mx-0">
              <div class="shadowclass count_alert">
                <h4 class="event-alert py-0 my-2">Alert </h4>
                <div class="row">
                  <div class="progress-comp eventDynamic">
                    <div class="event-time-edit">2022/05/16 10:00am </div>
                    <div class="past-due">
                      <p class="my-1">
                        <span class="pastSpan">Past Due :</span> Daily Count ALL
                      </p>
                    </div>
                    <div class="prog-buttons mx-0 mt-2">
                      <a href="/counts/count_sheet/755" class="">
                        Start Count
                      </a>{" "}
                    </div>
                  </div>
                </div>
              </div>{" "}
            </div>

            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Submitted Sheets</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />{" "}
                            <input type="submit" />
                          </form>
                        </div>{" "}
                      </div>
                    </div>

                    <div className="shadowclass mt-0 p-0">
                      <div className="table-responsive">
                        <table className="checklist-table remove-space inventory_table">
                          <thead>
                            <tr>
                              <th className="min-wd-150">Account</th>
                              <th>ID</th>
                              <th>Waste Type</th>
                              <th>Waste Group/Supplier</th>
                              <th># Of Waste Items</th>
                              <th>Total</th>
                              <th className="min-wd-200">Created</th>
                              <th className="action-td">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <strong>Boat Quay Pilot</strong>
                              </td>
                              <td>130</td>
                              <td>Waste Return </td>
                              <td>Ngoh Song Trader</td>

                              <td>1</td>
                              <td>$2.9000 </td>
                              <td>2022/05/12 13:14pm </td>
                              <td className="action-td">
                                <div className=" d-flex">
                                  <a href="#_" class="circle_icon">
                                    <i class="iconSprites eye-icon">
                                      {" "}
                                      <div class="tooltip-sm"> View </div>{" "}
                                    </i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <h4 class="event-alert flex-event">
                    <span>List of In-Progress/Scheduled Counts</span>
                    <a class="ad-hoc hover-btns" id="ad_hoc" href="#">
                      Ad Hoc Count
                    </a>
                  </h4>

                  <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                    <div class="search-box">
                      <form
                        action="/productions"
                        id="MenuItemIndexForm"
                        method="get"
                        accept-charset="utf-8"
                      >
                        {" "}
                        <input
                          name="keyword"
                          placeholder="Search"
                          type="text"
                          id="MenuItemKeyword"
                        />{" "}
                        <input type="submit" />
                      </form>
                    </div>{" "}
                  </div>

                  <div className="table-responsive">
                    <table className="checklist-table">
                      <thead>
                        <tr>
                          <th class="min-wd-150">Account</th>
                          <th className="min-wd-150">Status</th>
                          <th className="min-wd-150">Count Name</th>
                          <th className="min-wd-150">Frequency</th>
                          <th className="min-wd-200">Categories</th>
                          <th >Last Count</th>
                          <th >Next Count</th>
                          <th class="header"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Harry's HQ</strong>
                          </td>
                          <td width="">
                            <strong>Ready for Count</strong>
                          </td>
                          <td width="">
                            <strong>Daily Count ALL</strong>
                          </td>
                          <td width="">Daily (All Business Days) @ 10:00am </td>
                          <td width="">
                            Meat; Poultry; Seafood; Carbohydrates; Produce;
                            Herbs; Dairy; Oils &amp; Juices; Beer; Wine;
                            Spirits; Non-Alcoholic Beverages; Packaging;
                            Prepared Dishes
                          </td>
                          <td width="">2022-04-25 </td>
                          <td width="">2022-05-16 </td>
                          <td width="">
                            <a
                              href="/counts/count_sheet/755"
                              class="count-btn greenbuton-css"
                            >
                              Start Count
                            </a>{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <h4 class="event-alert">
                    <span>Submitted Counts</span>
                  </h4>

                  
                  <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                    <div class="search-box">
                      <form
                        action="/productions"
                        id="MenuItemIndexForm"
                        method="get"
                        accept-charset="utf-8"
                      >
                        {" "}
                        <input
                          name="keyword"
                          placeholder="Search"
                          type="text"
                          id="MenuItemKeyword"
                        />{" "}
                        <input type="submit" />
                      </form>
                    </div>{" "}
                  </div>

                  <div className="table-responsive">
                    <table className="checklist-table">
                      <thead>
                        <tr>
                          <th className="min-wd-150">Account</th>
                          <th className="text-center">ID</th>
                          <th className="text-right">Submission Date/Time</th>
                          <th className="min-wd-200">Count Name</th>
                          <th className="text-right">
                            # of Updated Ingredients
                          </th>
                          <th className="text-right"># of Updated Recipes</th>
                          <th className="text-right">
                            # of Updated Menu Items
                          </th>
                          <th className="action-td">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Harry's HQ</td>
                          <td className="text-center">1</td>
                          <td className="align-right">2022/04/25 19:50pm</td>
                          <td>
                            Monthly Count Last Business Day Low Cost Items
                          </td>
                          <td className="align-right">0</td>
                          <td className="align-right">0</td>
                          <td className="align-right">0</td>
                          <td className="action-td">
                            <div className="d-flex">
                              <a href="#_" class="circle_icon">
                                <i class="iconSprites eye-icon">
                                  {" "}
                                  <div class="tooltip-sm"> View </div>{" "}
                                </i>
                              </a>
                              <a href="#_" class="circle_icon">
                                <i class="iconSprites print-icon">
                                  {" "}
                                  <div class="tooltip-sm"> View </div>{" "}
                                </i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Counts;
